module.exports = __webpack_public_path__ + "media/KikiJC1.a2308b2d.mp3";